<template>
	<div class="fixwidth overflow_hide exampaper">
		<div class="fl paper">
			<!--标题开始-->
			<div class="title border">
				<div>
					<span v-for="tp in topicType" :key="tp.name" :class="tp.active?'font-active':''" @click="checkType(tp)">{{tp.name}}</span>
				</div>
			</div>
			<!--标题结束-->
			
			
			<!--题目开始-->
			<div class="topic border overflow_hide" style="border:1px solid #ddd;">
				<div v-for="(t,index) in topic" :key="index" v-if="t.creator===currentItemType">
					<div class="question" v-if="t.creator==='填空题'" >
						<span>{{index+1}}.</span>
						<span v-html="t.questionView.name"></span>
						<span style="margin-left:20px;">({{t.score}}分)</span>
					</div>
					<div class="question" v-else>{{index+1}}.{{t.questionView.name}}<span style="margin-left:20px;">({{t.score}}分)</span></div>
					<div v-if="t.creator==='单选题'||t.creator==='多选题'">
						<img v-if="t.questionView.url!==null" v-lazy="serverIp+t.questionView.url">
						<div class="answer" v-if="t.questionView.type==='单选题'||t.questionView.type==='多选题'">
							<div v-for="(a,tindex) in t.questionView.answerItems" :key="index" @click="chooseAnswer(a,t.questionView)">
								<span style="position: relative;left:0" class="input-radio" :class="a.active?'radio-active':''" >{{common.letter[tindex]}}</span>
								<label :for="a.id">
									<span>{{a.content}}</span>
									<img v-if="a.url!==null" v-lazy="serverIp+a.url">
								</label>
							</div>
						</div>
					</div>
					
					<div v-if="t.creator==='判断题'">
						<div  @click="judge(t.questionView,'1')">
							<span style="position: relative;left:0" class="input-radio" :class="t.questionView.chooseAnswer==='1'?'radio-active':''">&nbsp;</span>
							<label>正确</label>
						</div>
						<div  @click="judge(t.questionView,'0')">
							<span style="position: relative;left:0" class="input-radio" :class="t.questionView.chooseAnswer==='0'?'radio-active':''">&nbsp;</span>
							<label>错误</label>
						</div>
					</div>
					
					<div v-if="t.creator==='案例题'" >
						<div style="padding-left:20px;" v-for="(c,index) in t.questionView.childList" :key="index">
							<div>{{index+1}}.{{c.name}}</div>
							<div class="caseAnswer" v-for="(a,index) in c.answerItems" @click="caseChoose(a,c)" :key="index">
								<span style="position: relative;left:0" class="input-radio" :class="a.active?'radio-active':''" >{{common.letter[index]}}</span>
								<label :for="a.id">
									<span>{{a.content}}</span>
									<img v-if="a.url!==null" v-lazy="serverIp+a.url">
								</label>
							</div>
						</div>
					</div>
					
					<div v-if="t.creator==='填空题'">
						<div style="padding-left:20px;" v-for="(c,index) in t.questionView.answerItems" :key="index">
							<div><span class="input-radio">{{index+1}}</span>{{c.content}}</div>
						</div>
					</div>
				</div>
			</div>
			<!--题目结束-->
		</div>
	</div>
</template>

<script>
    export default {
        name: "PreviewExam",
        data(){
            return{
                topic:[],
                liNum:0,
                change:{
                    pre:require("../../assets/image/pre.png"),
                    next:require("../../assets/image/next.png")
                },
                topicType:[],
                current:1,
                clock:0,
                currentItemType:""
            }
        },
        created() {
            this.$json("/examination/paper/detail/"+this.$route.params.id,"GET",{}).then(res=>{
				this.topic = res.data;
                this.parseJson(this.topic);
                this.currentItemType = this.topicType[0].name;
                this.topicType[0].active = true;
            });
        },
        methods:{
            checkType(tp){
                this.currentItemType=tp.name;
                this.$nextTick(()=>{
                    this.topicType.forEach((t)=>{
                        this.$set(t,"active",false);
                    });
                    this.$set(tp,"active",true);
                })
            },
            setCache(obj){
                localStorage.removeItem("examPaper");
                localStorage.setItem("examPaper",JSON.stringify(obj));
            },
            pre(){
                if(this.current===1){
                    return false;
                }
                else this.current--;
            },
            next(){
                if(this.current===this.topic.length){
                    return false;
                }
                else this.current++;
            },
            //判断题选择
            judge(a,t){
                this.$nextTick(()=> {
                    this.$set(a,"chooseAnswer",t);
                });
            },
            //案例题选择
            caseChoose(a,t){
                this.$nextTick( ()=> {
                    t.answerItems.forEach(a=>{
                        this.$set(a, 'active', false);
                    });
                    this.$set(a, 'active', true);
                    this.$set(t,"chooseAnswer",a.answerNo);
                });
            },
            //选择题选择答案
            chooseAnswer(a,t){
                let arr= [];
                switch (t.type) {
                    case "单选题":
                        this.$nextTick( ()=> {
                            t.answerItems.forEach( (a)=>{
                                this.$set(a, 'active', false);
                            });
                            this.$set(a, 'active', true);
                            //this.$set(this.topic[this.current-1].questionView,"chooseAnswer",a.answerNo);
                            this.$set(t,"chooseAnswer",a.answerNo);
                        });
                        break;
                    case "多选题":
                        this.$nextTick(()=>{
                            this.$set(a,'active',!a.active);
                            for(let i in t.answerItems){
                                if(t.answerItems[i].active){
                                    arr.push(t.answerItems[i].answerNo)
                                }
                            }
                            this.$set(t,"chooseAnswer",arr.join(","));
                        });
                        break;
                }
            },
            //统计每个题目有多少道
            parseJson(json){
                let b ={};
                for(let i in json){
                    let id = json[i]['questionView']["type"];
                    if(b[id] === undefined)
                        b[id] = 1;
                    else
                        b[id] += 1;
                }
                for(let key in b){
                    this.topicType.push({"name":key,size:b[key]});
                }
            },
        },
        mounted() {
            /*window.onbeforeunload=function(){
                return '确定离开?将不会保存试卷'
            }*/
        },
        watch:{
            'current'(){
                let a= document.querySelectorAll(".li");
                for(let i=0;i<a.length; i++){
                    a[i].classList.remove("radio-active");
                    if(i===this.current-1){
                        a[i].classList.add("radio-active");
                    }
                }
            }
        }
    }
</script>

<style scoped lang="less">
	@import '../../assets/css/paper.less';
</style>
